"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.define-properties");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.split");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createLabel = exports.generateCommonPassedProps = exports.wrapperContent = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxForm = require("redux-form");

var _react = _interopRequireWildcard(require("react"));

var _validations = require("./validations");

var _propTypes = require("prop-types");

var _lodash = _interopRequireDefault(require("lodash"));

var _fieldsLegacy = _interopRequireDefault(require("./fieldsLegacy"));

var _fields = _interopRequireDefault(require("./fields"));

var _reactRedux = require("react-redux");

var _fieldStatic = _interopRequireWildcard(require("./fieldStatic"));

var _fieldsArray = _interopRequireWildcard(require("./fieldsArray"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var wrapperContent = function wrapperContent(_ref) {
  var collapseable = _ref.collapseable,
      _ref$i = _ref.i,
      i = _ref$i === void 0 ? 0 : _ref$i,
      label = _ref.label,
      smallLabel = _ref.smallLabel,
      description = _ref.description,
      question_description = _ref.question_description,
      title = _ref.title,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      fieldSpacing = _ref.fieldSpacing;
  return {
    collapseable: collapseable,
    smallLabel: smallLabel,
    label: label,
    question_description: question_description,
    key: i,
    description: description,
    title: title,
    style: _objectSpread(_objectSpread({
      marginBottom: fieldSpacing
    }, styles), config)
  };
};

exports.wrapperContent = wrapperContent;

var generateCommonPassedProps = function generateCommonPassedProps(_ref2) {
  var key = _ref2.key,
      disabled = _ref2.disabled,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["key", "disabled"]);
  var fieldName = key || props.name;
  var commonPassedProps = {
    name: fieldName,
    disabled: disabled
  };

  _lodash["default"].each(["normalize", "format", "parse"], function (attr) {
    if (_lodash["default"].isFunction(props[attr])) commonPassedProps[attr] = props[attr];
  });

  return {
    fieldName: fieldName,
    commonPassedProps: commonPassedProps
  };
};

exports.generateCommonPassedProps = generateCommonPassedProps;

var CuriousPandaField = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(CuriousPandaField, _PureComponent);

  var _super = _createSuper(CuriousPandaField);

  function CuriousPandaField(_props) {
    var _this;

    (0, _classCallCheck2["default"])(this, CuriousPandaField);
    _this = _super.call(this, _props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createDictionaryValidations", function (props) {
      return _lodash["default"].isFunction(_lodash["default"].get(_fields["default"][props["interface"]], 'validations')) ? _fields["default"][props["interface"]].validations(props) : [];
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkRender", function (_ref3) {
      var condition = _ref3.condition,
          valuesFromRedux = _ref3.valuesFromRedux,
          dispatch = _ref3.dispatch,
          name = _ref3.name;
      var conditionalCheckDisplay = true; // checking if we have a conditional set up for this field

      if (_lodash["default"].isFunction(condition)) {
        // running the `condition` method, should return a boolean
        var conditionalLogic = condition(name.split("."), {
          values: valuesFromRedux
        }); // checking for boolean, assume it is false if something other than bool is returned

        conditionalCheckDisplay = _lodash["default"].isBoolean(conditionalLogic) ? conditionalLogic : false;
      }

      _this.setState({
        display: conditionalCheckDisplay
      }, function () {
        if (!conditionalCheckDisplay) {
          dispatch((0, _reduxForm.clearFields)(_this.props.form, true, false, [name]));
        }
      });
    });
    _this.state = {
      display: true
    };
    _this.componentValidations = _this.createDictionaryValidations(_props);
    return _this;
  } // returns an array of validations
  // this allows us to create field validations that use settings configured in SM, ie: min, max


  (0, _createClass2["default"])(CuriousPandaField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // may not render by default
      this.checkRender(this.props);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if ( // only checking the render again if we have a conditional method
      // should reduce re-renders
      !_lodash["default"].has(this.props, "valuesFromRedux") && _lodash["default"].has(nextProps, "valuesFromRedux") || _lodash["default"].has(this.props, "valuesFromRedux") && _lodash["default"].has(nextProps, "valuesFromRedux") && !_lodash["default"].isEqual(this.props.valuesFromRedux, nextProps.valuesFromRedux)) {
        this.checkRender(nextProps);
      }
    } // checking should a field render using it's props passed

  }, {
    key: "render",
    value: function render() {
      if (!this.state.display) {
        return null;
      }

      var _this$props = this.props,
          intf = _this$props["interface"],
          label = _this$props.label,
          smallLabel = _this$props.smallLabel,
          description = _this$props.description,
          question_description = _this$props.question_description,
          title = _this$props.title,
          labelStyle = _this$props.labelStyle,
          inputStyle = _this$props.inputStyle,
          options = _this$props.options,
          _this$props$config = _this$props.config,
          config = _this$props$config === void 0 ? {} : _this$props$config,
          _this$props$validate = _this$props.validate,
          validate = _this$props$validate === void 0 ? [] : _this$props$validate,
          validations = _this$props.validations,
          fieldSpacing = _this$props.fieldSpacing,
          collapseable = _this$props.collapseable,
          nowDate = _this$props.nowDate,
          props = (0, _objectWithoutProperties2["default"])(_this$props, ["interface", "label", "smallLabel", "description", "question_description", "title", "labelStyle", "inputStyle", "options", "config", "validate", "validations", "fieldSpacing", "collapseable", "nowDate"]); // Static Fields

      if (_lodash["default"].includes(_fieldStatic.StaticFields, intf)) {
        return /*#__PURE__*/_react["default"].createElement(_fieldStatic["default"], (0, _extends2["default"])({}, _lodash["default"].pick(this.props, ['interface', 'name', 'onClick', 'buttonStyle', 'disabled']), {
          label: label || smallLabel
        }));
      } // Array


      if (_lodash["default"].includes(_fieldsArray.ArrayFields, intf)) {
        return /*#__PURE__*/_react["default"].createElement(_fieldsArray["default"], this.props);
      } // Field Dictionary


      if (_lodash["default"].has(_fields["default"][intf], 'component')) {
        var DictionaryComponent = _fields["default"][intf].component;
        var fieldValidations = props.required ? [].concat((0, _toConsumableArray2["default"])(validate), [_validations.required], (0, _toConsumableArray2["default"])(this.componentValidations)) : [].concat((0, _toConsumableArray2["default"])(validate), (0, _toConsumableArray2["default"])(this.componentValidations));
        return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, (0, _extends2["default"])({}, _lodash["default"].omit(this.props, 'submitting', 'dispatch', 'inputs', 'components', 'stateFromRedux', 'dispatch', 'condition', "displayMessage", "remoteSubmit"), {
          submitting: this.props.submitting,
          inputStyle: inputStyle,
          labelStyle: labelStyle,
          label: label || smallLabel,
          component: DictionaryComponent,
          validate: fieldValidations,
          config: _objectSpread(_objectSpread({}, props), config)
        }));
      } else if (_lodash["default"].has(_fields["default"][intf], 'field')) {
        // component uses redux field
        var Component = _fields["default"][intf].field;
        return /*#__PURE__*/_react["default"].createElement(Component, this.props);
      } // here be dragons


      return /*#__PURE__*/_react["default"].createElement(_fieldsLegacy["default"], _lodash["default"].omit(this.props, 'submitting', 'dispatch', 'inputs', 'stateFromRedux', 'dispatch', 'condition', "displayMessage", "remoteSubmit"));
    }
  }]);
  return CuriousPandaField;
}(_react.PureComponent);

CuriousPandaField.defaultProps = {
  disabled: false,
  ComponentWrapper: false
};
CuriousPandaField.propTypes = {
  ComponentWrapper: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.func, _propTypes.element]),
  "interface": (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, _propTypes.element]).isRequired,
  nowDate: _propTypes.object
};

var createLabel = function createLabel(_ref4) {
  var label = _ref4.label,
      name = _ref4.name,
      valuesFromRedux = _ref4.valuesFromRedux;
  if (_lodash["default"].isFunction(label)) return label(name.split('.'), {
    values: valuesFromRedux
  });else return label;
};

exports.createLabel = createLabel;

var _default = (0, _reactRedux.connect)(function (state, props) {
  var valuesFromRedux = _lodash["default"].has(state.form[props.form], "values") ? state.form[props.form].values : {};
  var fieldsFromRedux = _lodash["default"].has(state.form[props.form], "registeredFields") ? state.form[props.form].registeredFields : {};
  return {
    valuesFromRedux: valuesFromRedux,
    fieldsFromRedux: fieldsFromRedux,
    label: createLabel({
      name: props.name,
      label: props.label,
      valuesFromRedux: valuesFromRedux
    })
  };
})(CuriousPandaField);

exports["default"] = _default;